const Acheivements = {
	AvatarSelectionAcheivement: "AvatarSelectionAcheivement"
}

export default Acheivements;